/* ============================================================
   LIVRARIA — Sticky add-to-cart
   Barra fixa que surge ao rolar além do botão principal.
   O botão delega ao formulário real do produto (Dawn cuida
   de variante, quantidade e cart drawer). Código original.
   ============================================================ */
(function () {
  'use strict';

  class StickyAtc extends HTMLElement {
    connectedCallback() {
      this.btn = this.querySelector('.sticky-atc__btn');
      this.qtyInput = this.querySelector('.sticky-atc__qty-input');
      this.trigger =
        document.querySelector('product-form') ||
        document.querySelector('.product-form');
      this.setAttribute('aria-hidden', 'true');

      // O componente nasce invisível no CSS. Só libera a pintura depois
      // que o JS conectou e o navegador calculou o layout responsivo.
      requestAnimationFrame(() => {
        this.classList.add('is-ready');
      });

      // passos do seletor de quantidade
      this.querySelectorAll('[data-qty-step]').forEach((b) => {
        b.addEventListener('click', () => {
          if (!this.qtyInput) return;
          const step = parseInt(b.getAttribute('data-qty-step'), 10) || 0;
          const cur = parseInt(this.qtyInput.value, 10) || 1;
          this.qtyInput.value = Math.max(1, cur + step);
        });
      });

      if (this.btn) {
        this.btn.addEventListener('click', () => this.proxyAdd());
      }

      if (!this.trigger || !('IntersectionObserver' in window)) return;

      this.observer = new IntersectionObserver(
        (entries) => {
          const e = entries[0];
          const scrolledPast = !e.isIntersecting && e.boundingClientRect.top < 0;
          this.classList.toggle('is-active', scrolledPast);
          this.setAttribute('aria-hidden', String(!scrolledPast));
        },
        { threshold: 0 }
      );
      this.observer.observe(this.trigger);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    proxyAdd() {
      // Sempre delega ao formulário REAL do produto, que o Dawn intercepta
      // por AJAX e abre o cart drawer. Nunca usa form.submit() nativo
      // (isso navegaria para a página /cart — o que não queremos no mobile).
      const productForm = document.querySelector('product-form');
      const form =
        (productForm && productForm.querySelector('form')) ||
        document.querySelector('form[action*="/cart/add"]');
      if (!form) return;
      // sincroniza a quantidade escolhida no sticky com o formulário real
      const mainQty = form.querySelector('[name="quantity"]');
      if (mainQty && this.qtyInput) {
        mainQty.value = Math.max(1, parseInt(this.qtyInput.value, 10) || 1);
        mainQty.dispatchEvent(new Event('change', { bubbles: true }));
      }
      const addBtn = form.querySelector('[type="submit"], [name="add"]');
      if (addBtn) {
        addBtn.click();
      } else if (typeof form.requestSubmit === 'function') {
        form.requestSubmit();
      }
    }
  }

  if (!customElements.get('sticky-atc')) {
    customElements.define('sticky-atc', StickyAtc);
  }
})();
